import { render } from "./dialogAddItem.vue?vue&type=template&id=1500e5c9&scoped=true"
import script from "./dialogAddItem.vue?vue&type=script&lang=js"
export * from "./dialogAddItem.vue?vue&type=script&lang=js"

import "./dialogAddItem.vue?vue&type=style&index=0&id=1500e5c9&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1500e5c9"]])

export default __exports__